import styled from "styled-components";

const UppercaseInfo = styled.span`
    text-transform: uppercase;
    font-size: 25px;

    &.blue {
        color: blue;
    }

    img {
        width: 15px;
        margin-right: 5px;
        margin-bottom: 3px;
    }
`;

export default UppercaseInfo;